import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Button } from 'react-bootstrap';
import TourManager from '../TourManager';
import TourManagerModal from '../TourManagerModalContainer';
import { fromNow } from '../../../../core/date';
import MemberDetailModal from "./../MemberDetailModal"


function hasLength(value) {
  if (Object.prototype.hasOwnProperty.call(value, 'length')) {
    return value.length !== 0;
  }
  return false;
}

function formatSentOn(sentOn) {
  if (sentOn) {
    return (<p>Last sent: {fromNow(sentOn)}</p>);
  }
  return (<p>Click send to invite collaborators to tour.</p>);
}

class TourManagerWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      member: { is_shared: true }
    };

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }
  close() {
    this.setState({ showModal: false });
  }
  open() {
    this.setState({ showModal: true });
  }
  handleAddMember = (values) => {
    let obj = this.props.tour.members.find(o => o.email.toLowerCase() === values.email.toLowerCase());
    if(obj) {
      this.props.duplicateMemberError()
    }
    else {
      this.props.addMember(values)
    }
  }
  buildToolbar(readOnly, state, members) {
    if (readOnly) {
      return null;
    }
    if (state === 'AR') {
      return null;
    }
    return (
      <p>
        <Button bsStyle="info" onClick={this.open}>
          <i className="fa fa-share-alt" /> Share
        </Button>
      </p>
    );
  }
  formatManagers(members) {
    const memberList = [];
    members.forEach((tm) => {
      if (tm.is_shared) {
        memberList.push(
          <TourManager
            key={tm.id}
            tourId={this.props.tour.id}
            member={tm}
            readOnly={this.props.readOnly}
            dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
            
          />,
        );
      }
    });
    return memberList;
  }
  render() {
    let roster;

    const sentOn = formatSentOn(this.props.tour.sent_to_manager);

    if (hasLength(this.props.tour.members)) {
      const members = this.formatManagers(
        this.props.tour.members,
      );
      roster = (
        <div>
          {members}
          {sentOn}
        </div>);
    } else {
      roster = (
        <p>Share with clients to give them access to hotel selections.</p>
      );
    }
    const toolbar = this.buildToolbar(
      this.props.readOnly,
      this.props.tour.state,
      this.props.tour.members,
    );

    return (
      <div className="col-sm-3">
        <Panel header="Clients">
          {roster}
          {toolbar}
        </Panel>
        {this.state.showModal && (
          <MemberDetailModal
            tourId={this.props.tour.id}
            member={this.state.member}
            show={this.state.showModal}
            onClose={this.close}
            addMember={this.handleAddMember}
            groups={this.props.tour.groups}
            readOnly={this.props.readOnly}
            dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
          />
        )}
      </div>
    );
  }
}
TourManagerWidget.propTypes = {
  tour: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export default TourManagerWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/TourManagerWidget.js